// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.createMenuContainer {
  padding: 10px;
  background-color: #fff !important;
  font-size: 12px;
  margin: 30px 20px 0px 20px;
  border: 1px solid var(--surface-g1);
  border-radius: 8px;
}

.createMenuHeading {
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0%;
  color: var(--color-surface-black);
  margin-bottom: 10px;
}

.createMenuForm {
  margin-top: 10px;
}

.menuFieldHeading {
  font-weight: 700;
  margin-top: 10px;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 4px;
}

.mandatoryAstrike {
  color: red;
  font-weight: 400;
}

input[type="radio"] {
  cursor: pointer;
}

/* .createMenuForm input {
  padding: 7px 5px;
} */

.createMenuForm select {
  padding: 4px 5px !important;
}

.menuInput {
  width: 100% !important;
  margin-top: 5px;
  border-radius: 4px;
  border: 1px solid var(--surface-g2);
  padding: 10px 10px;
}

.menuSubInput {
  width: 100% !important;
  border-radius: 4px;
  border: 1px solid var(--surface-g2);
  padding: 10px 10px;
}

input.menuInput[type="number"]::-webkit-inner-spin-button,
input.menuSubInput[type="number"]::-webkit-inner-spin-button {
  transform: scale(1.3);
  margin-right: 2px;
  cursor: pointer;
} 

/* .menuInput input {
} */

.createMenuForm input::placeholder,
select {
  color: #ada8a8;
  font-weight: 700;
  font-size: 0.75rem;
}

.radioButtonsContainer input[type="radio"] {
  margin-right: 6px;
}

.radioButtonsContainer label {
  margin-right: 20px;
  cursor: pointer;
}

.dietaryTagContainer {
  margin-top: 10px;
}

.flexingDietaryButtons {
  display: flex;
  gap: 5px;
  margin-top: 1px;
}

.createMenuButton {
  display: flex;
  align-items: center;
  gap: 3px;
  border: 0;
  background: transparent;
  color: black;
  cursor: pointer;
}

.vegSelected {
  color: green;
  font-weight: 700;
  border: 0.25px solid green;
}

.nonVegSelected {
  color: red;
  font-weight: 700;
  border: 0.25px solid red;
}

.productVariantContainer {
  border: 0.2px solid #8d8787;
  padding: 10px;
  border-radius: 5px;
  background: #f5f5f5;
  margin-bottom: 15px;
}

.createMenuSaveButton {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}

.createMenuSaveButton button {
  background: linear-gradient(90deg, #4e6cf3 0%, #3448a3 100%);
  color: #fff;
  border: 0.5px solid #bebebe;
  border-radius: 4px;
  font-size: 0.75rem;
  padding: 8px 25px;
  cursor: pointer;
}

/* .salesChannelRadiButton input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  background-color: #fff;
  border: 2px solid #007bff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 8px;
  cursor: pointer;
  position: relative;
}

.salesChannelRadiButton input[type="radio"]::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 10px;
  height: 10px;
  background-color: #007bff;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
}

.salesChannelRadiButton input[type="radio"]:checked::before {
  transform: translate(-50%, -50%) scale(1);
}

.salesChannelRadiButton {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 1rem;
}

.salesChannelRadiButton label {
  margin-top: 2.1px;
} */

.menuUpload {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f3f1f1;
  padding: 48px 0px;
  justify-content: center;
}

.menuUploadWrapper {
  position: relative;
  display: inline-block;
  padding: 20px;
}

.menuUploadBorder {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.menuUploadInner {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 8px;
}

.menuUploadButton {
  background-color: #007aff;
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  padding: 5px 30px;
  border: 0;
  border-radius: 20px;
  cursor: pointer;
}

.uploadTextOne {
  font-weight: 500;
  font-size: 0.625rem;
  line-height: 100%;
  letter-spacing: 0%;
  color: #ada8a8;
}

.uploadTextTwo {
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 100%;
  letter-spacing: 0%;
}

.uomContainer {
  display: flex;
  gap: 10px;
}

.uomContainer .menuInput {
  max-width: 130px !important;
}

.addOnArea {
  background-color: #ffffff;
  border: 0.5px solid #949494;
  border-radius: 6px;
  margin-top: 10px;
}

.addOnArea p {
  margin: 10px 10px 10px 10px;
}

.addOnItem {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
/* .addOnArea ul{
  list-style: none;
  
}

.addOnArea ul li{
  cursor: pointer;
  border: 0.7px solid #BDBDBD;
  border-radius: 4px;
  padding: 4px 10px;
}

.addOnArea ul{
  padding: 0px 0px 0px 10px !important;
} */

.menuDropdown .soft-select__control {
  border: 1px solid var(--surface-g2);
  border-radius: 4px;
}

.coverImageHeading {
  margin-bottom: 5px;
}

.saleDetailLeftContainer {
  display: flex;
  gap: 10px;
}

.consent {
  display: flex;
  justify-content: flex-start;
  margin-top: 15px;
}

.menuCreationButtonContainer {
  display: flex;
  gap: 10px;
}

.saleModeSelection {
  margin-top: 1.25rem;
}

.disableFields {
  cursor: not-allowed;
}

/* ── Dark mode ── */
.dark .createMenuContainer {
  background-color: #1e293b !important;
  border-color: #334155;
  color: #f1f5f9;
}

.dark .createMenuHeading {
  color: #f1f5f9;
}

.dark .menuInput,
.dark .menuSubInput {
  background-color: #0f172a;
  border-color: #334155;
  color: #f1f5f9;
}

.dark .productVariantContainer {
  background: #0f172a;
  border-color: #334155;
}

.dark .menuUpload {
  background-color: #0f172a;
}

.dark .addOnArea {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .addOnArea p {
  color: #f1f5f9;
}

.dark .createMenuButton {
  color: #f1f5f9;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/settings/components/CreateMenuForm/CreateMenuForm.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iCAAiC;EACjC,eAAe;EACf,0BAA0B;EAC1B,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;;GAEG;;AAEH;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;GACG;;AAEH;;EAEE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,4DAA4D;EAC5D,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAsCG;;AAEH;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;AACA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,oCAAoC;EACpC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".createMenuContainer {\n  padding: 10px;\n  background-color: #fff !important;\n  font-size: 12px;\n  margin: 30px 20px 0px 20px;\n  border: 1px solid var(--surface-g1);\n  border-radius: 8px;\n}\n\n.createMenuHeading {\n  font-size: 1.25rem;\n  font-weight: 700;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: var(--color-surface-black);\n  margin-bottom: 10px;\n}\n\n.createMenuForm {\n  margin-top: 10px;\n}\n\n.menuFieldHeading {\n  font-weight: 700;\n  margin-top: 10px;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.mandatoryAstrike {\n  color: red;\n  font-weight: 400;\n}\n\ninput[type=\"radio\"] {\n  cursor: pointer;\n}\n\n/* .createMenuForm input {\n  padding: 7px 5px;\n} */\n\n.createMenuForm select {\n  padding: 4px 5px !important;\n}\n\n.menuInput {\n  width: 100% !important;\n  margin-top: 5px;\n  border-radius: 4px;\n  border: 1px solid var(--surface-g2);\n  padding: 10px 10px;\n}\n\n.menuSubInput {\n  width: 100% !important;\n  border-radius: 4px;\n  border: 1px solid var(--surface-g2);\n  padding: 10px 10px;\n}\n\ninput.menuInput[type=\"number\"]::-webkit-inner-spin-button,\ninput.menuSubInput[type=\"number\"]::-webkit-inner-spin-button {\n  transform: scale(1.3);\n  margin-right: 2px;\n  cursor: pointer;\n} \n\n/* .menuInput input {\n} */\n\n.createMenuForm input::placeholder,\nselect {\n  color: #ada8a8;\n  font-weight: 700;\n  font-size: 0.75rem;\n}\n\n.radioButtonsContainer input[type=\"radio\"] {\n  margin-right: 6px;\n}\n\n.radioButtonsContainer label {\n  margin-right: 20px;\n  cursor: pointer;\n}\n\n.dietaryTagContainer {\n  margin-top: 10px;\n}\n\n.flexingDietaryButtons {\n  display: flex;\n  gap: 5px;\n  margin-top: 1px;\n}\n\n.createMenuButton {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  border: 0;\n  background: transparent;\n  color: black;\n  cursor: pointer;\n}\n\n.vegSelected {\n  color: green;\n  font-weight: 700;\n  border: 0.25px solid green;\n}\n\n.nonVegSelected {\n  color: red;\n  font-weight: 700;\n  border: 0.25px solid red;\n}\n\n.productVariantContainer {\n  border: 0.2px solid #8d8787;\n  padding: 10px;\n  border-radius: 5px;\n  background: #f5f5f5;\n  margin-bottom: 15px;\n}\n\n.createMenuSaveButton {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 10px;\n}\n\n.createMenuSaveButton button {\n  background: linear-gradient(90deg, #4e6cf3 0%, #3448a3 100%);\n  color: #fff;\n  border: 0.5px solid #bebebe;\n  border-radius: 4px;\n  font-size: 0.75rem;\n  padding: 8px 25px;\n  cursor: pointer;\n}\n\n/* .salesChannelRadiButton input[type=\"radio\"] {\n  appearance: none;\n  -webkit-appearance: none;\n  background-color: #fff;\n  border: 2px solid #007bff;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  margin-right: 8px;\n  cursor: pointer;\n  position: relative;\n}\n\n.salesChannelRadiButton input[type=\"radio\"]::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 10px;\n  height: 10px;\n  background-color: #007bff;\n  border-radius: 50%;\n  transform: translate(-50%, -50%) scale(0);\n}\n\n.salesChannelRadiButton input[type=\"radio\"]:checked::before {\n  transform: translate(-50%, -50%) scale(1);\n}\n\n.salesChannelRadiButton {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 1rem;\n}\n\n.salesChannelRadiButton label {\n  margin-top: 2.1px;\n} */\n\n.menuUpload {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: #f3f1f1;\n  padding: 48px 0px;\n  justify-content: center;\n}\n\n.menuUploadWrapper {\n  position: relative;\n  display: inline-block;\n  padding: 20px;\n}\n\n.menuUploadBorder {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 1;\n}\n\n.menuUploadInner {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.menuUploadButton {\n  background-color: #007aff;\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 700;\n  padding: 5px 30px;\n  border: 0;\n  border-radius: 20px;\n  cursor: pointer;\n}\n\n.uploadTextOne {\n  font-weight: 500;\n  font-size: 0.625rem;\n  line-height: 100%;\n  letter-spacing: 0%;\n  color: #ada8a8;\n}\n\n.uploadTextTwo {\n  font-weight: 500;\n  font-size: 0.75rem;\n  line-height: 100%;\n  letter-spacing: 0%;\n}\n\n.uomContainer {\n  display: flex;\n  gap: 10px;\n}\n\n.uomContainer .menuInput {\n  max-width: 130px !important;\n}\n\n.addOnArea {\n  background-color: #ffffff;\n  border: 0.5px solid #949494;\n  border-radius: 6px;\n  margin-top: 10px;\n}\n\n.addOnArea p {\n  margin: 10px 10px 10px 10px;\n}\n\n.addOnItem {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n/* .addOnArea ul{\n  list-style: none;\n  \n}\n\n.addOnArea ul li{\n  cursor: pointer;\n  border: 0.7px solid #BDBDBD;\n  border-radius: 4px;\n  padding: 4px 10px;\n}\n\n.addOnArea ul{\n  padding: 0px 0px 0px 10px !important;\n} */\n\n.menuDropdown .soft-select__control {\n  border: 1px solid var(--surface-g2);\n  border-radius: 4px;\n}\n\n.coverImageHeading {\n  margin-bottom: 5px;\n}\n\n.saleDetailLeftContainer {\n  display: flex;\n  gap: 10px;\n}\n\n.consent {\n  display: flex;\n  justify-content: flex-start;\n  margin-top: 15px;\n}\n\n.menuCreationButtonContainer {\n  display: flex;\n  gap: 10px;\n}\n\n.saleModeSelection {\n  margin-top: 1.25rem;\n}\n\n.disableFields {\n  cursor: not-allowed;\n}\n\n/* ── Dark mode ── */\n.dark .createMenuContainer {\n  background-color: #1e293b !important;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .createMenuHeading {\n  color: #f1f5f9;\n}\n\n.dark .menuInput,\n.dark .menuSubInput {\n  background-color: #0f172a;\n  border-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .productVariantContainer {\n  background: #0f172a;\n  border-color: #334155;\n}\n\n.dark .menuUpload {\n  background-color: #0f172a;\n}\n\n.dark .addOnArea {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .addOnArea p {\n  color: #f1f5f9;\n}\n\n.dark .createMenuButton {\n  color: #f1f5f9;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
